<style lang="scss">
  #bottom {
    display: flex;
    justify-content: space-between;

    img {
      width: 23rem;
      max-width: 60%;
    }

    h5 {
      margin-right: 1rem;
    }
  }
</style>

<script>
  // Stores
  import {
    userCanBookFeatureDemoStore,
    userDataRefreshRequestedStore,
    userStore,
  } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  // Functions
  import { showToast, ToastError } from "@sourcewhale/core";
  import { requestAccess } from "../../../api/request-access";
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";

  const handleUserDataRefreshInterest = async () => {
    try {
      await requestAccess("Data Refresh");
      await userStore.get(); // refresh user store
    } catch (error) {
      if (error instanceof ToastError) {
        error.title = "Error requesting trial";
        showToast(error);
        return;
      }
      throw error;
    }
  };

  const handleDataRefreshDemoRequest = async () => {
    try {
      const { url } = await requestAccess("Data Refresh");
      window.location = url;
    } catch (error) {
      if (error instanceof ToastError) {
        error.title = "Error requesting trial";
        showToast(error);
        return;
      }
      throw error;
    }
  };

  $: buttonProps = {
    kind: "primary",
    disabled: $userDataRefreshRequestedStore,
    class: $userDataRefreshRequestedStore ? "disabled" : "",
    leadingIcon: $userDataRefreshRequestedStore ? "fa-solid fa-check" : "",
    onclick: $userCanBookFeatureDemoStore
      ? handleDataRefreshDemoRequest
      : handleUserDataRefreshInterest,
  };
</script>

<div id="bottom">
  <div id="cta">
    <Button {...buttonProps}>
      {#if $userCanBookFeatureDemoStore}
        {#if $userDataRefreshRequestedStore}
          Demo booked
        {:else}
          Book a demo
        {/if}
      {:else if $userDataRefreshRequestedStore}
        Registered
      {:else}
        Register interest
      {/if}
    </Button>

    {#if $userDataRefreshRequestedStore && !$userCanBookFeatureDemoStore}
      <h5>
        Thank you for registering! We'll be in touch with you soon to discuss
        next steps
      </h5>
    {/if}
  </div>
  <img
    src="../../../../assets/img/data-refresh-promo/contacts-image.png"
    alt="Contacts"
  />
</div>
